"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = void 0;
class Field {
    constructor(_fieldImpl) {
        this._fieldImpl = _fieldImpl;
    }
    get name() {
        return this._fieldImpl.name;
    }
    get id() {
        return this._fieldImpl.id;
    }
    get description() {
        return this._fieldImpl.description;
    }
    get dataType() {
        return this._fieldImpl.dataType;
    }
    get aggregation() {
        return this._fieldImpl.aggregation;
    }
    get dataSource() {
        return this._fieldImpl.dataSource;
    }
    get role() {
        return this._fieldImpl.role;
    }
    get columnType() {
        return this._fieldImpl.columnType;
    }
    get isCalculatedField() {
        return this._fieldImpl.isCalculatedField;
    }
    get isCombinedField() {
        return this._fieldImpl.isCombinedField;
    }
    get isGenerated() {
        return this._fieldImpl.isGenerated;
    }
    get isGeospatial() {
        return this._fieldImpl.isGeospatial;
    }
    get isHidden() {
        return this._fieldImpl.isHidden;
    }
    get isPresentOnPublishedDatasource() {
        return this._fieldImpl.isPresentOnPublishedDatasource;
    }
    get semanticRole() {
        return this._fieldImpl.semanticRole;
    }
    get dataFormat() {
        return this._fieldImpl.dataFormat;
    }
}
exports.Field = Field;
//# sourceMappingURL=Field.js.map